import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { DynamicBarService } from "./_components/dynamic-bar/dynamic-bar.service";


@Component({
  templateUrl: 'not-found.component.html',
  styleUrls: ['not-found.component.scss'],
  standalone: false,
  
  
})

export class NotfoundComponent implements OnInit {

  // Animación de partículas (opcional)
  particles = Array(50).fill(0).map((_, i) => ({
    left: Math.random() * 100 + '%',
    top: Math.random() * 100 + '%',
    size: Math.random() * 10 + 5 + 'px',
    delay: Math.random() * 5 + 's'
  }));

  constructor(
    private title: Title,
    private dynamicBarra: DynamicBarService
  ) { }

  ngOnInit() {
    this.title.setTitle('Inicio/Página no encontrada');
    this.dynamicBarra.setBarra('barra-simple', {
      titulos: [
        // { texto: 'Inicio', link: ['/'] },
        { texto: 'Página no encontrada', link: [] },
      ],
    });
  }
}
